import React from 'react';
import { useInvalidSection } from '../metroline/invalid-section';
import { useExternalUrlGroupsConfiguration, getExternalUrlGroupsRoute } from '../metroline/external-url-group-configuration';
import { ExternalUrlGroupItem } from '../types-store';
import { ExternalUrlGroupsFormProps } from '../types';
import { ExternalUrlGroupsFormRenderer } from './external-url-group-form-renderer';

export const ExternalUrlGroupsFormSections: React.FC<ExternalUrlGroupsFormProps> = ({
  actionType, formState, mainLanguage, options, externalUrlOptions, section, locale, translation,
  externalUrlAccess, showTranslations, translationAdminAccess, shouldPrompt,
  changeLanguage, copyLanguageToAll, changeLongDescription, copyLongDescriptionToAll,
  saveExternalUrlGroup, deleteExternalUrlGroup, updateValidation, displayError,
  updateItem, loadOptions, loadExternalUrlOptions, switchTranslationsToggle, updateAccessPolicyItem, removeAccessPolicy,
  addAccessPolicy, resetAccessPolicyClientValidation, resetAccessPolicyServerValidation, removeAllAccessPolicy,
  updateExternalUrl, addExternalUrls, deleteExternalUrl, deleteAllExternalUrls
}) => {

  const scrollViewUrl = getExternalUrlGroupsRoute(actionType, formState.externalUrlGroupItem?.id);

  const configuration = useExternalUrlGroupsConfiguration(
    actionType,
    formState.externalUrlGroupItem?.id,
    formState.validation,
    formState.accessPolicyValidation,
    formState.exterenalUrlsValidation
  );

  const [invalidSection, updateInvalidSection] = useInvalidSection(configuration, formState.validation);

  const onSaveExternalUrlGroup = (externalUrlGroup: ExternalUrlGroupItem) => {
    updateInvalidSection(undefined);
    saveExternalUrlGroup(externalUrlGroup);
  };

  return <ExternalUrlGroupsFormRenderer
    showTranslations={showTranslations}
    switchTranslationsToggle={switchTranslationsToggle}
    actionType={actionType}
    formState={formState}
    shouldPrompt={shouldPrompt}
    mainLanguage={mainLanguage}
    saveExternalUrlGroup={onSaveExternalUrlGroup}
    deleteExternalUrlGroup={deleteExternalUrlGroup}
    updateItem={updateItem}
    changeLanguage={changeLanguage}
    copyLanguageToAll={copyLanguageToAll}
    changeLongDescription={changeLongDescription}
    copyLongDescriptionToAll={copyLongDescriptionToAll}
    options={options}
    loadOptions={loadOptions}
    externalUrlOptions={externalUrlOptions}
    loadExternalUrlOptions={loadExternalUrlOptions}
    updateValidation={updateValidation}
    displayError={displayError}
    locale={locale}
    validation={formState.validation}
    translation={translation}
    label={translation.external_urls}
    section={section}
    initialSection={section}
    configuration={configuration}
    scrollViewUrl={scrollViewUrl}
    invalidSection={invalidSection}
    translationAdminAccess={translationAdminAccess}
    externalUrlAccess={externalUrlAccess}
    removeAccessPolicy={removeAccessPolicy}
    addAccessPolicy={addAccessPolicy}
    removeAllAccessPolicy={removeAllAccessPolicy}
    updateAccessPolicyItem={updateAccessPolicyItem}
    resetAccessPolicyClientValidation={resetAccessPolicyClientValidation}
    resetAccessPolicyServerValidation={resetAccessPolicyServerValidation}
    accessPolicyValidation={formState.accessPolicyValidation}
    addExternalUrls={addExternalUrls}
    updateExternalUrl={updateExternalUrl}
    deleteExternalUrl={deleteExternalUrl}
    deleteAllExternalUrls={deleteAllExternalUrls}
    externalUrlsValidation={formState.exterenalUrlsValidation} />;
};
